import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const HeaderButton = ({icon, onClick})=>{
    return <div className="text-blue-600 w-10 h-10 flex justify-center items-center cursor-pointer">
        <FontAwesomeIcon size="2x" icon={icon} onClick={onClick} />
    </div>
}

export default HeaderButton
